export default __webpack_public_path__ + "static/media/box.4f35e3b4.png";